import { render, staticRenderFns } from "./ResetQueueButton.vue?vue&type=template&id=483e6ed9&scoped=true&"
import script from "./ResetQueueButton.vue?vue&type=script&lang=js&"
export * from "./ResetQueueButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483e6ed9",
  null
  
)

export default component.exports